import React from "react";
import "./DownloadApps.scss";

const DownloadApps = () => {
  return (
    <div className="download-section">
      <h2>Download Our Apps</h2>
      <div className="download-links">
        <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Download on Play Store"
          />
        </a>
        <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="Download on App Store"
          />
        </a>
      </div>
    </div>
  );
};

export default DownloadApps;
